import { render, staticRenderFns } from "./ElLabel.vue?vue&type=template&id=6db8a58b"
import script from "./ElLabel.vue?vue&type=script&lang=js"
export * from "./ElLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports